var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('neopass-tour', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.currentPage === '/neopass' && _vm.onBoarding.tourNeopass === true,
      expression: "currentPage === '/neopass' && onBoarding.tourNeopass === true"
    }],
    attrs: {
      "name": "tourNeopass",
      "steps": _vm.stepsNeopass
    },
    on: {
      "tourSkipped": function ($event) {
        return _vm.tourSkipped();
      },
      "tourFinished": function ($event) {
        return _vm.tourFinished();
      }
    }
  }), _vm._v(" "), _c('neopass-tour', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: /\/form\/neopass\/[0-9]*/.test(_vm.currentPage) && _vm.onBoarding.tourNeopassForm === true,
      expression: "/\\/form\\/neopass\\/[0-9]*/.test(currentPage) && onBoarding.tourNeopassForm === true"
    }],
    attrs: {
      "name": "tourNeopassForm",
      "steps": _vm.stepsNeopassForm
    },
    on: {
      "tourSkipped": function ($event) {
        return _vm.tourSkipped();
      },
      "tourFinished": function ($event) {
        return _vm.tourFinished();
      }
    }
  }), _vm._v(" "), _c('neopass-tour', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: /modeles-de-page/.test(_vm.currentPage) && _vm.onBoarding.tourModele === true,
      expression: "/modeles-de-page/.test(currentPage) && onBoarding.tourModele === true"
    }],
    attrs: {
      "name": "tourModele",
      "steps": _vm.stepsModele
    },
    on: {
      "tourSkipped": function ($event) {
        return _vm.tourSkipped();
      },
      "tourFinished": function ($event) {
        return _vm.tourFinished();
      }
    }
  }), _vm._v(" "), _c('neopass-tour', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.currentPage === '/fiches-de-poste' && _vm.onBoarding.tourBibliperso === true && _vm.personalLibrary === true,
      expression: "currentPage === '/fiches-de-poste' && onBoarding.tourBibliperso === true && personalLibrary === true"
    }],
    attrs: {
      "name": "tourBibliperso",
      "steps": _vm.stepsBibliperso
    },
    on: {
      "tourSkipped": function ($event) {
        return _vm.tourSkipped();
      },
      "tourFinished": function ($event) {
        return _vm.tourFinished();
      }
    }
  }), _vm._v(" "), _c('neopass-tour', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.currentPage === '/fiches-de-poste' && _vm.onBoarding.tourBiblicommune === true && _vm.personalLibrary === false,
      expression: "currentPage === '/fiches-de-poste' && onBoarding.tourBiblicommune === true && personalLibrary === false"
    }],
    attrs: {
      "name": "tourBiblicommune",
      "steps": _vm.stepsBiblicommune
    },
    on: {
      "tourSkipped": function ($event) {
        return _vm.tourSkipped();
      },
      "tourFinished": function ($event) {
        return _vm.tourFinished();
      }
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }